<script setup lang="ts">
const verbatimEl = ref<HTMLElement | null>(null);
const parentVerbatimEl = computed<HTMLElement | null>(() => {
  if (!verbatimEl.value) return null;

  return verbatimEl.value.parentElement;
});

// @FIXME: Can't use StyleValue here due to typescript error
const numLines = ref<number>(4);

watch([verbatimEl, parentVerbatimEl], () => {
  if (verbatimEl.value == null || parentVerbatimEl.value == null) {
    return;
  }

  let computedLineHeight = document.defaultView
    ?.getComputedStyle(verbatimEl.value, null)
    .getPropertyValue('line-height');
  const fontSize = document.defaultView?.getComputedStyle(verbatimEl.value, null).getPropertyValue('font-size');
  if (computedLineHeight == 'normal') computedLineHeight = String(1.3 * parseFloat(fontSize ?? '12'));

  const computedParentMargin =
    parseFloat(
      document.defaultView?.getComputedStyle(parentVerbatimEl.value, null).getPropertyValue('padding-bottom') ?? '0'
    ) +
    parseFloat(
      document.defaultView?.getComputedStyle(parentVerbatimEl.value, null).getPropertyValue('padding-top') ?? '0'
    );

  numLines.value = Math.min(
    4, // max of 4 lines shown
    Math.trunc((parentVerbatimEl.value.clientHeight - computedParentMargin) / parseInt(computedLineHeight ?? '1'))
  );
});

defineProps<{ content: string }>();
</script>
<template>
  <div
    ref="verbatimEl"
    :style="{ '-webkit-line-clamp': numLines }"
    class="[display:-webkit-box] overflow-hidden webkit-box-orient-vertical"
  >
    {{ content }}
  </div>
</template>
